<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row>
        <el-col :md="9" :lg="9">
          <el-date-picker v-model="created" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="dateChange" format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd" size="mini">
          </el-date-picker>
        </el-col>
      </el-row>

      <div class="recharge-overview view-flex content-center content-padded" style="width: 60%;"  v-loading="loading">
        <div class="view-flex-item">
          <i class="iconfont icon-donate"></i>
          <div><span>订单总金额</span> <span class="money mark">{{ybData.yborderPrice}}</span> </div>
        </div>
        <div class="view-flex-item">
<!--            <i class="iconfont icon-credit-card1"></i>-->
          <i class="iconfont icon-clipboard-list"></i>
          <div>订单数 <span class="money mark">{{ybData.yborderCount}}</span> </div>
        </div>
        <div class="view-flex-item">
          <i class="iconfont icon-dolly-flatbed"></i>
          <div><span>销售数</span> <span class="money mark">{{ybData.goodsNum}}</span> </div>
        </div>
        <div class="view-flex-item">
          <i class="iconfont icon-user-clock"></i>
          <div><span>分享点击数</span> <span class="money mark">{{ybData.clickNum}}</span> </div>
        </div>
        <div class="view-flex-item">
          <i class="iconfont icon-user-tie"></i>
          <div><span>会员数</span> <span class="money mark">{{ybData.membersNum}}</span> </div>
        </div>
        <div class="view-flex-item">
          <i class="iconfont icon-donate"></i>
          <div><span>退款订单金额</span> <span class="money mark">{{ybData.yborderRefundPrice}}</span> </div>
        </div>
        <div class="view-flex-item">
          <i class="iconfont icon-clipboard-list"></i>
          <div><span>退款订单数</span> <span class="money mark">{{ybData.yborderRefundCount}}</span> </div>
        </div>
      </div>
      <div style="width: 50%;height: 250px;float: left;margin-top: 35px;">
        <span style="display: block;color: #ff5000;" v-if="isData">推客排行(点击数)</span>
        <table class="gridtable" v-if="isData">
          <thead>
          <tr>
            <th>账号</th>
            <th>姓名</th>
            <th>点击数</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(vo,index) in tuikeRankingClick">
            <td v-text="vo.sharer_mobile"></td>
            <td v-text="vo.sharer_name"></td>
            <td v-text="vo.clickNum"></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div style="width: 50%;height: 250px;float: left;margin-top: 35px;">
        <span style="display: block;color: #ff5000;" v-if="isData">推客排行(订单数)</span>
        <table class="gridtable" v-if="isData">
          <thead>
          <tr>
            <th>账号</th>
            <th>姓名</th>
            <th>订单数</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(vo,index) in tuikeRanking">
            <td v-text="vo.sharer_mobile"></td>
            <td v-text="vo.sharer_name"></td>
            <td v-text="vo.sharer_orderCount"></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div style="width: 50%;float: left;margin-top: 35px;">
        <span style="display: block;color: #ff5000;" v-if="isData">商品排行(点击量)</span>
        <canvas id="myChart" height="100"></canvas>
      </div>
      <div style="width: 50%;float: left;margin-top: 35px;">
        <span style="display: block;color: #ff5000;" v-if="isData">商品排行(订单量)</span>
        <canvas id="myChart2" height="100"></canvas>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {getJingying, getTuikeRanking, getTuikeRankingClick, getGoodsRankingClick, getGoodsRankingOrder} from '../../../api/sharer'
import Style from "../../pc/footerPage/components/plugins/footer/style";
import chart from 'chart.js'
export default {
  components: {Style},
  data () {
    return {
      loading: false,
      params: {
        page: 1,
        pageSize: 5
      },
      isData: 0,
      ybData: [],
      tuikeRanking: [],
      tuikeRankingClick: [],
      goodsRankingClick: [],
      goodsRankingOrder: [],
      created: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      line_chart: '',
      line_chart2: ''
    }
  },
  computed: {
    // 默认时间
    timeDefault () {
      let date = new Date()
      // 通过时间戳计算
      let defalutStartTime = date.getTime() - 7 * 24 * 3600 * 1000 // 转化为时间戳
      let defalutEndTime = date.getTime()
      let startDateNs = new Date(defalutStartTime)
      let endDateNs = new Date(defalutEndTime)
      // 月，日 不够10补0
      defalutStartTime = startDateNs.getFullYear() + '-' + ((startDateNs.getMonth() + 1) >= 10 ? (startDateNs.getMonth() + 1) : '0' + (startDateNs.getMonth() + 1)) + '-' + (startDateNs.getDate() >= 10 ? startDateNs.getDate() : '0' + startDateNs.getDate())
      defalutEndTime = endDateNs.getFullYear() + '-' + ((endDateNs.getMonth() + 1) >= 10 ? (endDateNs.getMonth() + 1) : '0' + (endDateNs.getMonth() + 1)) + '-' + (endDateNs.getDate() >= 10 ? endDateNs.getDate() : '0' + endDateNs.getDate())
      this.params.time_start_begin = this.dateStrToTimeStamp(defalutStartTime + ' 00:00:00')
      this.params.time_start_end = this.dateStrToTimeStamp(defalutEndTime + ' 23:59:59')
      this.getItems(this.params)
      this.getTuikeRanking(this.params)
      this.getTuikeRankingClick(this.params)
      this.getGoodsRankingClick(this.params)
      this.getGoodsRankingOrder(this.params)
      return [defalutStartTime, defalutEndTime]
    }
  },
  methods: {
    getItems (filter) {
      this.loading = true
      getJingying(filter).then(response => {
        // console.log(response)
        this.ybData = response.data.data
        this.isData = 1
        // this.yborderPrice = response.data.data.yborderPrice
        // this.yborderCount = response.data.data.yborderCount
        this.loading = false
      })
    },
    getTuikeRanking (filter) {
      // this.loading = true
      getTuikeRanking(filter).then(response => {
        this.tuikeRanking = response.data.data.list
        // this.loading = false
      })
    },
    getTuikeRankingClick (filter) {
      // this.loading = true
      getTuikeRankingClick(filter).then(response => {
        this.tuikeRankingClick = response.data.data.list
        // this.loading = false
      })
    },
    getGoodsRankingClick (filter) {
      getGoodsRankingClick(filter).then(response => {
        var goodsRankingClick = response.data.data.list
        var skuName = []
        var clickNum = []
        goodsRankingClick.forEach(el => {
          skuName.push(el.sharer_sku_name)
          clickNum.push(el.clickNum)
        })
        this.chartInit(skuName, clickNum)
      })
    },
    getGoodsRankingOrder (filter) {
      getGoodsRankingOrder(filter).then(response => {
        var goodsRankingOrder = response.data.data.list
        var skuName = []
        var goodsNum = []
        goodsRankingOrder.forEach(el => {
            skuName.push(el.sharer_sku_name)
            goodsNum.push(el.goodsNum)
        })
        this.chartInit2(skuName, goodsNum)
      })
    },
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      // console.log(this.params)
      this.getItems(this.params)
      this.getTuikeRanking(this.params)
      this.getTuikeRankingClick(this.params)
      this.getGoodsRankingClick(this.params)
      this.getGoodsRankingOrder(this.params)
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str)) / 1000
    },
    chartInit (skuName, clickNum) {
      if(this.line_chart)
      {
        this.line_chart.destroy();
      }
      var config = {
        type: 'horizontalBar',
        data: {
          labels: skuName,
          datasets: [{
            label: '# of 点击量',
            data: clickNum,
            backgroundColor: [
              'rgba(54, 162, 235, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(54, 162, 235, 0.2)'
            ],
            borderColor: [
              'rgba(54, 162, 235, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(54, 162, 235, 1)'
            ],
            borderWidth: 1,
          }]
        },
        options: {
          title: {
            display: false,
            text: '条形图1 - 水平条形图'
          }
        }
      }
      var ctx = document.getElementById('myChart').getContext("2d");
      this.line_chart = new Chart(ctx, config);
    },
    chartInit2 (skuName, goodsNum) {
      if(this.line_chart2)
      {
        this.line_chart2.destroy();
      }
      var config = {
        type: 'horizontalBar',
        data: {
          labels: skuName,
          datasets: [{
            label: '# of 订单量',
            data: goodsNum,
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 99, 132, 0.2)'
            ],
            borderColor: [
              'rgba(255, 99, 132, 1)',
              'rgba(255, 99, 132, 1)',
              'rgba(255, 99, 132, 1)',
              'rgba(255, 99, 132, 1)',
              'rgba(255, 99, 132, 1)'
            ],
            borderWidth: 1,
          }]
        },
        options: {
          title: {
            display: false,
            text: '条形图2 - 水平条形图'
          }
        }
      }
      var ctx = document.getElementById('myChart2').getContext("2d");
      this.line_chart2 = new Chart(ctx, config);
    }
  },
  created () {
    this.created = this.timeDefault
  },
  mounted () {
    // this.getItems(this.params)
  },
  watch: {
    // 分页全选-监听数据变化
  }
}
</script>
<style scoped lang="scss">
.recharge-overview {
.iconfont {
  font-size: 50px;
  color: #ff5000;
  margin-bottom: 10px;
}
}
</style>

<style type="text/css">
table.gridtable {
  width: 80%;
  text-align: center;
  font-family: verdana,arial,sans-serif;
  font-size:11px;
  color:#333333;
  border-width: 1px;
  border-color: #666666;
  border-collapse: collapse;
}
table.gridtable th {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebe5e5;
  background-color: #dedede;
}
table.gridtable td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebe5e5;
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// jingying.vue?e4181a8a